import { useEffect } from 'react';
import cx from 'classnames';

// @ts-expect-error - no TypeScript definitions yet
import { ErrorMessage } from 'src/components/ErrorMessage';
import { Loader } from 'src/components/Loader';
import { ReviewerNavigationBar } from 'src/views/ReviewerNavigationBar';

import { ReviewerDocument } from './views/ReviewerDocument';
import styles from './ReviewerProjectPage.module.scss';
import { REVIEWER_PROJECT_LOAD_ERROR } from './store';
import { useHandlers } from './useHandlers';
import { useViewState } from './useViewState';

interface ReviewerProjectPageProps {
  className?: string;
  projectId: string;
}

/** A project shared for review: its saved document, read-only, with comments and ratings. */
export const ReviewerProjectPage = ({ className, projectId }: ReviewerProjectPageProps) => {
  const { project, loading, error } = useViewState();
  const { handleAccessLost } = useHandlers();

  useEffect(() => {
    if (error === REVIEWER_PROJECT_LOAD_ERROR.accessLost) {
      handleAccessLost();
    }
  }, [error, handleAccessLost]);

  const renderContent = () => {
    if (loading) {
      return <Loader className={styles.loader} />;
    }
    if (error === REVIEWER_PROJECT_LOAD_ERROR.failed) {
      return (
        <ErrorMessage
          className={styles.message}
          error="Couldn’t load the project. Please try again later."
        />
      );
    }
    if (!project) {
      return null;
    }
    return (
      <ReviewerDocument
        projectId={projectId}
        editorContent={project.editorContent ?? ''}
        onAccessLost={handleAccessLost}
      />
    );
  };

  return (
    <div
      className={cx(styles.root, className)}
      data-testid="ReviewerProjectPage"
    >
      <ReviewerNavigationBar projectName={project?.name ?? null} />
      {renderContent()}
    </div>
  );
};
